import { WSElementProps, WSInfoBox } from "@wingspanhq/fe-component-library";

export const InProgressBanner: React.FC<WSElementProps> = props => (
  <WSInfoBox title="" {...props}>
    We're currently migrating your account from Blue Ridge Bank to Lead Bank.
    This upgrade will enhance your banking experience with Wingspan. Here's what
    to expect:
    <br />
    <br />
    <ul>
      <li>
        <b>Limited Access</b>: During migration, you cannot perform account
        actions (including transfers).
      </li>
      <li>
        <b>Duration</b>: The migration process takes about 24 hours. Full
        functionality will be restored by next business morning.
      </li>
      <li>
        <b>Balance</b>: Your balance may show as "pending" during the
        transition.
      </li>
      <li>
        <b>Fund Transfer</b>: You'll see two new entries in your transaction
        list:
        <ol>
          <li>
            Blue Ridge Bank Draw Down: This shows your funds leaving your old
            Blue Ridge Bank account.
          </li>
          <li>
            Lead Bank Opening Balance: This shows the same funds arriving in
            your new Lead Bank account.
          </li>
        </ol>
      </li>
    </ul>
    <br />
    These transactions represent the transfer of your funds from Blue Ridge Bank
    to Lead Bank. The total amount will remain the same
    <br />
    <br />
    Your funds are secure throughout this process. Normal account functionality
    with Lead Bank will resume automatically once complete.
  </WSInfoBox>
);
